export enum LocationGroupActionType {
  Rename = 1,
  Delete = 2,
  CreateCopy = 3,
}
